import { StringFilterMenuComponent } from './string-filter-menu.component';
import { NumericFilterMenuComponent } from './numeric-filter-menu.component';
import { DateFilterMenuComponent } from './date-filter-menu.component';
import { BooleanFilterMenuComponent } from './boolean-filter-menu.component';
/**
 * @hidden
 *
 * > List the following components as `entryComponents` in the GridModule.
 */
export var filterMenuComponentFactory = function (type) { return ({
    "boolean": BooleanFilterMenuComponent,
    "date": DateFilterMenuComponent,
    "numeric": NumericFilterMenuComponent,
    "text": StringFilterMenuComponent
}[type]); };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/filtering/menu/filter-menu-component.factory.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/filtering/menu/filter-menu-component.factory.js
// module chunks = vendor